interface HomeIconProps {
  size?: number;
  className?: string;
}

const HomeIcon: React.FC<HomeIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <path
        d="M8 1.6 1 7.6h1.6v6.8h3.8V9.8h3.2v4.6h3.8V7.6H15L8 1.6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HomeIcon;
